import { useEffect, useState } from "react";
import { getAllowParticipants } from "../../api/rooms/getAllowParticipant";
import { useInfo } from "../../hooks/useInfo";
import styled from "styled-components";


const Container = styled("div")`
  display: ${(props) => (props.hidden ? "none" : "flex")};
  box-sizing: border-box;
  z-index: auto;
  @container (max-width: 560px) {
    width: 100%;
  }
`;

const PatientItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
`;

const PatientWrapper = styled("div")`
  width: 100%;
`;

const Patient = styled("span")`
  font-size: 14px;
`;

interface WaitingPatient {
  patientId: number;
  name: string;
}

export const WaitingListPreview = () => {
  const [participants, setParticipants] = useState<WaitingPatient[]>([]);
  const [loading, setLoading] = useState(true);
  const { telemedicineData } = useInfo();

  useEffect(() => {
    fetchWaitingPatients();
    const interval = setInterval(fetchWaitingPatients, 3000);
    return () => clearInterval(interval);
  }, []);


  const fetchWaitingPatients = async () => {
    try {
      const data = await getAllowParticipants(telemedicineData.id);
      setParticipants(data.patients || []);
    } catch (err) {
      console.error("Erro ao buscar pacientes aguardando:", err);
      setParticipants([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <PatientWrapper>
        {participants.map(participant => (
          <PatientItem key={participant.patientId}>
            <Patient><strong>{participant.name}</strong> está aguardando para entrar na sala</Patient>
          </PatientItem>
        ))}
      </PatientWrapper>
    </Container>
  );
};
